<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('common.tenant') }}</h1>
      <div class="details-component__header_right" v-if="!isDeleted()">
        <router-link :to="{name: 'export-tenants-details', params: { id: selectedTenantId }}" class="link" v-if="selectedTenantId">
          {{ $t('top_bar.generate_report') }}
          <i class="icon icon--rows"></i>
        </router-link>
        <router-link :to="{name: 'edit-tenant', params: { id: selectedTenantId }}" class="link" v-if="selectedTenantId">
          {{ $t('common.change') }}
          <i class="icon icon--arrow"></i>
        </router-link>

        <!-- <a v-if="tenant.user && !tenant.user.account_created && tenant.user.email !== ''" href="#" class="link--orange" @click="activateTenantAccount(tenant.user.id)">{{ $t('tenant_details.create_account') }}
          <i class="icon icon--plus"></i>
        </a>-->
        <!--<a v-if="tenant.user && tenant.user.account_created && tenant.user.email !== ''" href="#" class="link" @click="resetPassword(tenant.user.email)">Taasta parool
          <i class="icon icon--plus"></i>
        </a>-->
        <a v-if="isLandlord()" v-on:click="showDeletingConfirmation" class="link link--orange">{{ $t('common.delete') }}&nbsp;<i class="icon icon--cross"></i></a>
      </div>
    </div>
    <div class="details-component__content content">
      <table class="details-table tenant no-col-padding label-r-padding fixed-table label-col-wide-260">
        <tr class="details-table__row" v-if="isSuperAdmin() && tenant.landlord">
          <td class="details-table__col details-table__col_label">{{ $t('common.landlord') }}</td>
          <td class="details-table__col landlord__name">{{ tenant.landlord.name || tenant.name }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.tenant') }}</td>
          <td class="details-table__col tenant__name">{{ tenant.name }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('tenant_details.contact_person') }}</td>
          <td class="details-table__col">{{ tenant.contactPerson }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.address') }}</td>
          <td class="details-table__col">{{ tenant.address }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('tenant_details.reg_code') }}</td>
          <td class="details-table__col">{{ tenant.regCode }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('tenant_details.legal_address') }}</td>
          <td class="details-table__col">{{ tenant.legalAddress }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('tenant_details.vat_number') }}</td>
          <td class="details-table__col">{{ tenant.vatNumber }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.phone') }}</td>
          <td class="details-table__col">{{ tenant.phoneNumber }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('tenant_details.since') }}</td>
          <td class="details-table__col">{{ tenant.createdAt }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.email') }}</td>
          <td class="details-table__col">{{ tenant.email }}</td>
        </tr>
        <tr v-if="tenant.scoroId" class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.scoroId') }}</td>
          <td class="details-table__col">{{ tenant.scoroId }}</td>
        </tr>
      </table>


      <ConfirmationModal v-if="showConfirmationModal" @cancel="cancelTenantDelete" @confirmed="deleteTenant">
        <h1 slot="header">{{ $t('common.deleting') }}: {{ tenant.name }} </h1>
        <p slot="body">{{ $t('tenants.confirm_delete') }}</p>
      </ConfirmationModal>

      <WarningModal v-if="showWarningModal" @close="closeWarningModal">
        <h1 slot="header">{{ tenantWarningHeader }}</h1>
        <p slot="body">{{ tenantWarningBody }}</p>
      </WarningModal>

    </div>
  </div>
</template>

<script>
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';

export default {
  props: ['tenant'],
  components: {
    ConfirmationModal,
    WarningModal,
  },
  computed: mapGetters({
    coordinates: 'tenants/tenant/coordinates',
    selectedTenantId: 'tenants/tenant/selectedTenantId',
    tenants: 'landlord/tenants/tenants',
    tenantsError: 'tenants/tenant/error',
    user: 'user/user/user',
  }),
  methods: {
    isDeleted() {
      this.$emit('isDeleted', this.tenant.isDeleted);
      return this.tenant.isDeleted;
    },
    activateTenantAccount(userId) {
      this.$store.dispatch('tenants/tenant/activateTenantAccount', { user: userId }).then(() => {
        this.showModal = true;
      });
    },
    showDeletingConfirmation() {
      this.showConfirmationModal = true;
    },
    deleteTenant() {
      this.showConfirmationModal = false;
      this.$store.dispatch('tenants/tenant/delete', { id: this.selectedTenantId, user: this.user }).then(() => {
        if (this.tenantsError) {
          this.tenantWarningHeader = this.$t('common.deleting');
          this.tenantWarningBody = this.$t('tenants.delete_error');
          this.showWarningModal = true;
        } else {
          this.$store.commit(`landlord/tenants/${mTypes.REMOVE_DATA}`, this.selectedTenantId);
          this.$router.push({ name: 'tenants' });
        }
      });
    },
    cancelTenantDelete() {
      this.showConfirmationModal = false;
    },
    closeWarningModal() {
      this.showWarningModal = false;
      this.$store.commit(`tenants/tenant/${mTypes.DATA_ERROR}`, null);
    },
  },
  data() {
    return {
      showConfirmationModal: false,
      showWarningModal: false,
      tenantWarningBody: null,
      tenantWarningHeader: null,
      columns: ['name', 'email', 'createdAt', 'remove_account'],
      options: {
        filterable: false,
        rowClassCallback: () => 'VueTables__row',
        headings: {
          name: () => this.$t('common.name'),
          email: () => this.$t('common.email'),
          createdAt: () => this.$t('common.created_at'),
          remove_account: () => (''),
        },
        templates: {
          remove_account: (h, row) => (
            <div class="delete-wrapper">
              <a on-click={ () => this.showConfirmationForRemovingAccount(row) }>
                <span class="delete-wrapper__icon icon icon--cross"></span>
              </a>
            </div>
          ),
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
@import '~styles/blocks/details.scss';

.tenant__name {
  font-size: 24px;
  font-family: 'Geogrotesque Md', sans-serif;
}

.link--orange {
  .icon--plus {
    position: relative;
    top: 1px;
    margin: 0;
    font-weight: 900;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tenants/TenantDetails.vue